import React  from "react";
import { Form, Col } from "react-bootstrap";
import { ApplicantContainer} from "../unstated/applicant";
import { Fragment } from "react";
import SectionHeader from "../containers/SectionHeader";

export default function Qualification() {
    
  let app = ApplicantContainer.useContainer();    

  let inputQualification = app.inStdValues.frQualification;

  let strSectionHeader = "SECTION B: QUALIFICATION";

  const addQualification = index => {    

    const values = [...inputQualification];
    values.splice(index+1, 0, {   highest: false, qualification: '', grade: ''});

    app.onChangeInStdValues({...app.inStdValues, frQualification:values});
  }

  const delQualification = index => {    

    if(inputQualification.length === 1) return 0;

    const values = [...inputQualification];    
    values.splice(index, 1);

    if(values.length === 1) values[0].highest = true;       
  
    app.onChangeInStdValues({...app.inStdValues, frQualification:values}); 
  }

  const handleInputChange = (inputname, index, event) => {        
    const values = [...inputQualification];  
    
    if(event.target.type === 'radio') {
      values.map((inputField, currIndex) => {
        if(currIndex !== index) 
          inputField.highest=false;
          return values;
        });
    } 
    values[index].[inputname] = event.target.type === 'radio' ? event.target.checked : event.target.value;


    app.onChangeInStdValues({...app.inStdValues, frQualification:values}); 

  };

  return (
<>

<SectionHeader strSectionHeader={strSectionHeader} />

<Form.Row className="d-none d-sm-flex">
  <Col xs={12} sm={1} md={1}  lg={1} className='table-header'>
    <Form.Group as={Col} >
    <Form.Label>Highest</Form.Label>
    </Form.Group>
  </Col>
  <Col xs={12} sm={7} md={7}  lg={7} className='table-header pl-4'>
    <Form.Group as={Col} >
    <Form.Label>Qualification</Form.Label>
    </Form.Group>
  </Col>
  <Col xs={12} sm={2} md={2}  lg={2} className='table-header'>
    <Form.Group as={Col} >
      <Form.Label>Grade</Form.Label>
    </Form.Group>
  </Col>
  <Col xs={12} sm={2} md={2}  lg={2} className='table-header d-flex justify-content-center'>          
    <Form.Group as={Col}  className="segbutton">
      <Form.Label>action</Form.Label>
  </Form.Group>
  </Col>        
</Form.Row> 


{inputQualification.map((inputField, index) => (      
  <Fragment key={`${inputField}~${index}`}>

    <Form.Row >
      <Col xs={12} sm={1} md={1}  lg={1}>
        <Form.Group as={Col}>
            <Form.Label className="d-flex d-sm-none">Highest</Form.Label>
          <Form.Control name="formHighest" size="sm" type="radio" placeholder="" checked={inputField.highest} onChange={event => handleInputChange('highest', index, event)} />
        </Form.Group>
      </Col>
      <Col xs={12} sm={7} md={7}  lg={7}>
        <Form.Group as={Col}>
        <Form.Label className="d-flex d-sm-none">Qualification</Form.Label>
          <Form.Control name="formQualification" required type="text" placeholder="" value={inputField.qualification} onChange={event => handleInputChange('qualification', index, event)} />
          <Form.Control.Feedback type="invalid">
            Please enter your qualification.
          </Form.Control.Feedback>      
        </Form.Group>
      </Col>
      <Col xs={12} sm={2} md={2}  lg={2}>
        <Form.Group as={Col}>
        <Form.Label className="d-flex d-sm-none">Grade</Form.Label>
          <Form.Control name="formGrade" required type="text" placeholder="i.e for Grade: 5A, 2B" value={inputField.grade} onChange={event => handleInputChange('grade', index, event)} />
          <Form.Control.Feedback type="invalid">
            Please enter your grade.
          </Form.Control.Feedback>      
        </Form.Group>
      </Col>
      <Col xs={12} sm={2} md={2} lg={2} className="d-flex justify-content-center">
        <Form.Group as={Col} className="segbutton">
          <Form.Control name="formQualificationAdd" type="button" className="add btn btn-outline-primary" value="+" onClick={() => addQualification(index)} />&nbsp;
        </Form.Group>  
        <Form.Group as={Col} className="segbutton">
          <Form.Control name="formQualificationDel" type="button" className="del btn btn-outline-danger" value="-" onClick={() => delQualification(index)} />
        </Form.Group>
      </Col>        
    </Form.Row> 
    <hr className="d-flex d-sm-none" />
  </Fragment>
  
  ))}
</>
    );
}